function precomputeStimSize(trialRow) {
    const option = window.columnForTrial('stimSize', trialRow);

    if(option === "na") {
        return [];
    }
    const sizes = option.split(';');
    const newSizes = [];

    var sizesCount = sizes.length;
    if(sizesCount === 1) {
        sizesCount = window.stimFieldsMax;
        for(var i = 0; i < sizesCount; i++) {
            newSizes[i] = parseStimSize(sizes[0], trialRow);
        }
    } else {
        for(var i = 0; i < sizesCount; i++) {
            newSizes[i] = parseStimSize(sizes[i], trialRow);
        }
    }

    return newSizes;
}

function parseStimSize(sizeOption, trialRow) {
    if (isTrialOfType(trialRow, 'word')) {
        const percentage = parseInt(sizeOption, 10);
        if (percentage) {
            return {type: 'word', size: (2 * percentage / 100) + 'em'};
        } else {
            return {type: 'word', size: '2em'};
        }
    } else {
        const resizeOptionRegex = /^((\d+ \d+)|(max \d+ \d+)|(max \d+)|(\d+\%)|(\d+))$/gm;
        const matches = resizeOptionRegex.exec(sizeOption);
        if (matches === null) {
            return;
        } else if (matches[2]) {
            const sizes = matches[2].split(' ');
            const newWidth = sizes[0];
            const newHeight = sizes[1];

            return function(width, height) {
                if (width === 0 || height === 0) return {type: 'media', width: 0, height: 0};
                return {type: 'media', width: newWidth, height: newHeight};
            }
        } else if (matches[3]) {
            const stimSizeOptions = matches[3].split(' ');
            const newMaxWidth = stimSizeOptions[1];
            const newMaxHeight = stimSizeOptions[2];

            return function(width, height) {
                if (width === 0 || height === 0) return {type: 'media', width: 0, height: 0};
                const option = {type: 'media'};
                if (width > newMaxWidth || height > newMaxHeight) {
                    var widthRatio = newMaxWidth / width;
                    var heightRatio = newMaxHeight / height;
                    var scaleRatio = widthRatio < heightRatio ? widthRatio : heightRatio
                    option.width = width * scaleRatio;
                    option.height = height * scaleRatio
                } else {
                    option.width = width;
                    option.height = height;
                }
                return option;
            }

        } else if (matches[4]) {
            const stimSizeOptions = matches[4].split(' ');
            const newMaxWidth = stimSizeOptions[1];
            return function(width, height) {
                if (width === 0 || height === 0) return {type: 'media', width: 0, height: 0};
                const option = {type: 'media'};
                if (width > newMaxWidth) {
                    var scaleRatio = newMaxWidth / width;
                    option.width = width * scaleRatio
                    option.height = height * scaleRatio;
                } else {
                    option.width = width;
                    option.height = height;
                }
                return option;
            }
        } else if (matches[5]) {
            var multiplier = parseInt(matches[5], 10) / 100;
            
            return function(width, height) {
                return {type: 'media', width: width * multiplier, height: height * multiplier}
            }
        } else if (matches[6]) {
            // proportional scaling (width wise)
            var givenWidth = parseInt(matches[6], 10);
            return function(width, height) {
                if (width === 0 || height === 0) return {type: 'media', width: 0, height: 0};
                const percentage = givenWidth / width;
                return {type: 'media', width: givenWidth, height: height * percentage};
            }
        }
    }
}